$(document).ready(function () {
  $("[data-date]").each(function () {
    var $this = $(this),
      finalDate = $(this).data("date");
    $this.countdown(finalDate, function (event) {
      $this.find(".days").html(event.strftime("%D"));
      $this.find(".hours").html(event.strftime("%H"));
      $this.find(".minutes").html(event.strftime("%M"));
      $this.find(".seconds").html(event.strftime("%S"));
    });
  });

  $(".banner-section-content").owlCarousel({
    loop: true,
    autoplay: true,
    autoplayTimeout: 5000,
    margin: 10,
    nav: false,
    dots: true,
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 1,
      },
      1000: {
        items: 1,
      },
    },
  });

  $(".offer-item-section").owlCarousel({
    loop: false,
    autoplay: true,
    autoplayTimeout: 5000,
    margin: 10,
    nav: false,
    dots: true,
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 2,
      },
      900: {
        items: 3,
      },      
      1200: {
        items: 4,
      },
      1600: {
        items: 5,
      },
    },
  });

  $(".smart-everywhere-content").owlCarousel({
    loop: false,
    margin: 10,
    nav: false,
    dots: true,
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 1,
      },
      1000: {
        items: 1,
      },
    },
  });

  $("#filterOptions li a").click(function () {
    // fetch the class of the clicked item
    var ourClass = $(this).attr("class");

    // reset the active class on all the buttons
    $("#filterOptions li").removeClass("active");
    // update the active state on our clicked button
    $(this).parent().addClass("active");

    if (ourClass == "all") {
      // show all our items
      $(".ourHolder").find("li.grid__item").show();
    } else {
      // hide all elements that don't share ourClass
      $(".ourHolder")
        .find("li:not(." + ourClass + ")")
        .hide();
      // show all elements that do share ourClass
      $(".ourHolder")
        .find("li." + ourClass)
        .show();
    }
    return false;
  });
});


document.querySelectorAll('.field__input').forEach(inputElement => {
    inputElement.addEventListener('input', function() {
        var fieldLabel = this.closest('.field').querySelector('.field__label');
        if(this.value.length >= 1) {
            // Hide label
            fieldLabel.style.display = 'none';
        } else {
            // Show label
            fieldLabel.style.display = 'block';
        }
    });
});

function hideShowLabelOnInput(inputElemId) {
    let inputElem = document.getElementById(inputElemId);
    if(inputElem) { // Check if element exists
        inputElem.addEventListener('input', function (e) {
            let nextSiblings = getNextSiblings(e.target);
            nextSiblings.forEach(sibling => {
                if (sibling.tagName.toLowerCase() === 'label') {
                    sibling.style.display = e.target.value.length >= 1 ? 'none' : 'inline';
                }
            });
        });
    }
}

function getNextSiblings(elem) {
    let siblings = [];
    while (elem = elem.nextSibling) {
        if (elem.nodeType === 1) {
            siblings.push(elem);
        }
    }
    return siblings;
}

// For input elements with names
function hideShowLabelForInputName(inputName) {
    let inputElem = document.querySelector(`input[name="${inputName}"]`);
    if(inputElem) { // Check if element exists
        inputElem.addEventListener('input', function (e) {
            let nextSiblings = getNextSiblings(e.target);
            nextSiblings.forEach(sibling => {
                if (sibling.tagName.toLowerCase() === 'label') {
                    sibling.style.display = e.target.value.length >= 1 ? 'none' : 'inline';
                }
            });
        });
    }
}

// Adding event listeners to specific elements by ID
hideShowLabelOnInput('RegisterForm-FirstName');
hideShowLabelOnInput('RegisterForm-LastName');
hideShowLabelOnInput('RegisterForm-email');
hideShowLabelOnInput('RegisterForm-password');
hideShowLabelOnInput('CustomerEmail');
hideShowLabelOnInput('CustomerPassword');
hideShowLabelOnInput('RecoverEmail');
hideShowLabelOnInput('Filter-Price-GTE');
hideShowLabelOnInput('Filter-Price-LTE');



// Adding event listener for input element with name
hideShowLabelForInputName('customer[first_name]');


console.log("hi from custom.js")

function openProduct(productHandle) {
    // Construct the URL using the product handle
    const productUrl = `/products/${productHandle}`;
    window.location.href = productUrl;
  }

   function handleCartAction(product, button) {
    // Toggle action based on button text

     console.log(button.innerText)
     //return;

     
    if (button.innerText === 'ADD TO CART') {
      addToCart(product, button);
    } else {
     fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          const lineItem = cart.items.findIndex(item => item.id === product) + 1; // +1 because line item indices are 1-based
          if (lineItem > 0) {
            removeFromCart(lineItem, button);
          }
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    }
  }

function addToCart(variantId, button) {
    // Construct form data
    let formData = new FormData();
    formData.append('form_type', 'product');
    formData.append('utf8', '✓');
    formData.append('id', variantId);
    formData.append('sections', 'cart-drawer,cart-icon-bubble');
    formData.append('sections_url', '/');

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok.');
      }
      return response.json();
    })
    .then(data => {
      console.log('Item added to cart:', data);

        

      
      button.innerText = 'REMOVE FROM CART'; // Update button text
      // Update cart drawer and cart icon bubble using data from response
      // ... (update your DOM elements as necessary)
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}
 


  function removeFromCart(product, button) {
    // Replace with the correct variant ID attribute as per your product object
    let variantId = product

    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        line: variantId, 
        quantity: 0,
        sections_url: "/",
        sections: [
            "cart-drawer",
            "cart-icon-bubble"
          ]
      })
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok.');
      }
      return response.json();
    })
    .then(data => {
      console.log('Item removed from cart:', data);
      button.innerText = 'ADD TO CART'; // getting button is undefined
      window.location.reload()
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  } 


document.addEventListener('DOMContentLoaded', function() {
  // Fetch the current cart
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      cart.items.forEach((cartItem) => {
        if (productVariantIds.includes(cartItem.id)) {
          // Update button text based on whether the product is in the cart
          const cartButton = document.querySelector(`button[data-variant-id="${cartItem.id}"]`);
          if (cartButton) {
            cartButton.innerText = 'Remove from Cart';
          }
        }
      });
    })
    .catch(error => {
      console.error('Error:', error);
    });
});

function addRedirectAction() {
  // URLs to be redirected to
  const urlDefault = "https://snapshotlb.com/collections/tenon";
  const urlLastItem = "https://snapshotlb.com/collections/avatto";
  
  // Select all elements with the class 'slide-media-desktop'
  const elements = document.querySelectorAll('.slideshow');
  const elements2 = document.querySelectorAll('.image-smart-247'); 
  

  elements2.forEach((element, index) => {
    // Add click event listener to each element
    element.addEventListener('click', () => {      
        // Otherwise, redirect to urlDefault
        window.location.href = urlLastItem;     
    });

    

    
  });
}

// Call the function to add redirect action to elements
addRedirectAction();



